/* eslint-disable */
export default {
  onSearching: 'Laden...',
  noContacts: 'Geen opnamen gevonden.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
